/**
 * Legacy color tokens — kept exported for backward compat with ~40 files that
 * still import from here. Values now map to the Direction C DARK theme so the
 * whole app renders cohesively without needing to refactor every call-site.
 *
 * For new code, prefer `useTheme()` from ../context/ThemeContext so the token
 * responds to light/dark toggles.
 */
export default {
  // --- neutrals remapped to dark-theme surfaces + text ---
  white: "#131417",         // was pure white → now the main card surface
  almostBlack: "#ededed",   // was primary text color on light bg → now primary text on dark bg
  lighGray: "#8b8c92",      // muted text / hints
  lighestGray: "#18191c",   // was page background-ish → now "surface 2" (nested card)

  // Scale (cool grays → dark theme tiers)
  darkest: "#111214",       // used to be very dark — kept dark
  darker: "#0957A2",        // button primaries → blue brand
  dark: "#2570BD",          // brand 2 (slightly lighter blue)
  teal: "#2570BD",          // used as an accent → brand 2
  lighter: "#1e1f23",       // surface 3 (hover / chip)
  lightest: "#222327",      // border

  // Navigation / accent
  blue: "#0957A2",          // legacy "navigation" color → blue brand
  lightBlue: "#2570BD",
  darkBlue: "#111214",
  navigationColor: "#0957A2",
  navigationTintColor: "#ffffff",

  // --- semantic (kept close to original intent so indicators still read right) ---

  // Nooz score scales
  noozscoreSentiment: "#636f9b",
  noozscorePropaganda: "#8792be",
  noozscoreOpinion: "#1e3f93",
  noozscoreRevision: "#3e4665",
  noozscoreGhostEdits: "#B47070",

  // Objectivity
  objectivityUnfill: "#3a3f55",
  objectivity76to100: "#2570BD",
  objectivity51to75: "#1F65B0",
  objectivity26to50: "#0F4F8E",
  objectivity1to25: "#073A66",
  objectivity0: "#1a2840",

  // Sentiment
  sentimentNegativeUnfill: "#4a2a28",
  sentimentPositiveUnfill: "#2a4a36",
  sentimentDeactivated: "#2a2d3a",
  sentimentPositiveFilled: "#4cb782",
  sentiment0: "#3a3f55",
  sentimentNegativeFilled: "#e05b59",

  // Revision
  revisionUnfill: "#3a3f55",
  revision76to100: "#2570BD",
  revision51to75: "#1F65B0",
  revision26to50: "#0F4F8E",
  revision2to25: "#073A66",
  revision1: "#1a2840",
};
